/**
 * Копирование текста в буфер без внешних зависимостей.
 * Сначала Clipboard API, затем резервный textarea + execCommand.
 */
export async function copyTextToClipboard(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Падаем на резервный способ ниже.
    }
  }

  fallbackCopyText(text);
}

function fallbackCopyText(text: string): void {
  if (typeof document === 'undefined') {
    throw new Error('Буфер обмена недоступен');
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.width = '1px';
  textarea.style.height = '1px';
  textarea.style.padding = '0';
  textarea.style.border = 'none';
  textarea.style.outline = 'none';
  textarea.style.boxShadow = 'none';
  textarea.style.background = 'transparent';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  let succeeded = false;
  try {
    succeeded = document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
  }

  if (!succeeded) {
    throw new Error('Не удалось скопировать текст');
  }
}
